import { unitById } from "@zend/content";

/** Native tanks point +X; humanoids/tripods point Blender -Y (glTF +Z). */
export function modelForwardCorrection(defId: string): number {
  return defId.startsWith("unit.") && unitById(defId).chassis === "tank" ? -Math.PI / 2 : 0;
}

export function targetYaw(from: { x: number; z: number }, to: { x: number; z: number }): number {
  return Math.atan2(to.x - from.x, to.z - from.z);
}
